import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import CMSContentItem from "../CMSContentItem";
import _ from "lodash";
import { ContentType, ModelType } from "../../../types";
import BlogJsonLd from "../Blog/BlogJson";
import BlogItemList from "../Blog/BlogItemList";
import { ImageDataLike } from "gatsby-plugin-image";
interface CMSContentListProps {
    modelID: string;
    transformation: string;
    displayCount?: number;
}
export default function CMSContentList({ modelID, transformation: transformationId, displayCount }: CMSContentListProps) {

    const { allContent, allModel } = useStaticQuery(graphql`
        query {
            allContent {
                nodes {
                    id
                    modelId
                    data
                    imageFile {
                        childImageSharp {
                            gatsbyImageData(
                                layout: FULL_WIDTH
                                placeholder: BLURRED
                                formats: [AUTO, WEBP, AVIF]
                            )
                        }
                    }
                }
            }
            allModel{
                nodes{
                    id
                    name
                    modelId
                    transformations{
                        id
                        name
                        html
                    }
                }
            }
        }
    `);

    const modelMap = _.keyBy(allModel.nodes, "id");
    const model = modelMap[modelID] as (Pick<ModelType, "id" | "name" | "modelId" | "transformations"> | undefined);

    if (!model) {
        console.warn(`Model with ID ${modelID} not found`);
        return null;
    }

    const contentMap = _.groupBy(allContent.nodes, "modelId");
    const contentForModel: (Pick<ContentType, "id" | "modelId" | "data"> & { imageFile: ImageDataLike })[] = contentMap[modelID] ?? [];

    if (model.modelId === "blog") {
        return <BlogItemList model={model} content={contentForModel} showJsonLd={true} />;
    }

    return (
        <>
            {contentForModel.map(content => {
                return (
                    <CMSContentItem
                        key={content.id}
                        model={model}
                        content={content}
                        selectedTransformationId={transformationId}
                    />
                );
            })}
        </>
    );
}
